module.exports = __webpack_public_path__ + "img/frame (202).6d03848c.jpg";